<script>
import { Bar as chart } from 'vue-chartjs';
import bc from './base-chart';
export default {
  extends: bc,
  mixins: [chart],
  methods: {
  },
};
</script>